/* ==========================================================================
   dcc-cookies.js — Zustimmung einsammeln und an Shopify weiterreichen.

   Die Zustimmung selbst verwaltet weiterhin Shopify. Dieses Skript liefert
   nur die Oberflaeche davor und ruft am Ende

       Shopify.customerPrivacy.setTrackingConsent({...})

   auf. Damit gilt dieselbe Zustimmung wie beim Shopify-Banner, sie wird an
   derselben Stelle gespeichert und von Apps und Pixeln genauso gelesen.

   DER RUECKFALL IST DER WICHTIGE TEIL
   Wir blenden Shopifys Banner per CSS aus, sobald `dcc-cookies-bereit` auf
   <html> steht. Kommt Shopifys API nicht zustande — Skript blockiert, Netz
   weg, Feature abgeschaltet —, nehmen wir die Klasse wieder herunter. Dann
   erscheint Shopifys Banner. Ein Laden ohne jede Abfrage darf es nie geben.
   ========================================================================== */

(function () {
  'use strict';

  var WURZEL = document.documentElement;
  var BEREIT = 'dcc-cookies-bereit';

  // So frueh wie moeglich: Shopifys Banner verstecken, damit es nicht
  // aufblitzt. Wird unten zurueckgenommen, falls wir nicht liefern koennen.
  WURZEL.classList.add(BEREIT);

  var banner = document.querySelector('[data-dcc-cookies]');
  if (!banner) { WURZEL.classList.remove(BEREIT); return; }

  var leiste     = banner.querySelector('[data-dcc-leiste]');
  var wahl       = banner.querySelector('[data-dcc-wahl]');
  var knopfMehr  = banner.querySelector('[data-dcc-oeffnen]');
  var felder     = banner.querySelectorAll('[data-dcc-feld]');

  var privacy = null;   // Shopify.customerPrivacy, sobald geladen

  /* ---------------------------------------------------------------------
     Aufgeben: Oberflaeche weg, Shopifys Banner wieder zulassen.
     --------------------------------------------------------------------- */
  function aufgeben(grund) {
    WURZEL.classList.remove(BEREIT);
    WURZEL.classList.remove('dcc-ck-sperre');
    banner.hidden = true;
    if (window.console && console.warn) {
      console.warn('[dcc-cookies] Faellt auf Shopifys Banner zurueck:', grund);
    }
  }

  /* ---------------------------------------------------------------------
     Anzeigen / Verbergen
     --------------------------------------------------------------------- */
  /* Fenster-Modus: mittig, Hintergrund abgedunkelt, Seite gesperrt, bis entschieden ist.
     Ausnahme Datenschutz/Impressum – dort bleibt die Leiste, damit man vorher lesen kann. */
  var FREI = /^\/(pages\/(datenschutz|impressum)|policies\/)/;
  var modal = !FREI.test(location.pathname);
  var vorherFokus = null;

  function fokusFalle(e) {
    if (e.key !== 'Tab' || banner.hidden) return;
    var z = Array.prototype.filter.call(
      banner.querySelectorAll('button, a[href], input:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!z.length) return;
    var erst = z[0], letzt = z[z.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
    else if (!banner.contains(document.activeElement)) { e.preventDefault(); erst.focus(); }
  }

  function zeigen() {
    banner.hidden = false;
    if (!modal) return;
    banner.classList.add('dcc-ck--modal');
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-modal', 'true');
    WURZEL.classList.add('dcc-ck-sperre');
    vorherFokus = document.activeElement;
    document.addEventListener('keydown', fokusFalle, true);
    var erster = banner.querySelector('[data-dcc-alle]');
    if (erster) { try { erster.focus({ preventScroll: true }); } catch (e) { erster.focus(); } }
  }

  function verbergen() {
    banner.hidden = true;
    banner.classList.remove('dcc-ck--modal');
    banner.setAttribute('role', 'region');
    banner.removeAttribute('aria-modal');
    WURZEL.classList.remove('dcc-ck-sperre');
    document.removeEventListener('keydown', fokusFalle, true);
    if (vorherFokus && vorherFokus.focus && vorherFokus !== document.body) { try { vorherFokus.focus({ preventScroll: true }); } catch (e) {} }
    vorherFokus = null;
    if (wahl) wahl.hidden = true;
    if (knopfMehr) knopfMehr.setAttribute('aria-expanded', 'false');
  }

  function wahlUmschalten() {
    if (!wahl || !knopfMehr) return;
    var offen = !wahl.hidden;
    wahl.hidden = offen;
    knopfMehr.setAttribute('aria-expanded', String(!offen));
    if (!offen) {
      // beim Oeffnen den Stand der Kaestchen aus der aktuellen Zustimmung holen
      standEinlesen();
      var erstes = wahl.querySelector('input:not([disabled])');
      if (erstes) erstes.focus();
    }
  }

  /* ---------------------------------------------------------------------
     Zustimmung setzen. `sale_of_data` laeuft mit `marketing` mit — es geht
     in beiden Faellen um Weitergabe an Dritte zu Werbezwecken.
     --------------------------------------------------------------------- */
  function setzen(werte) {
    if (!privacy) { aufgeben('customerPrivacy fehlt beim Speichern'); return; }
    try {
      privacy.setTrackingConsent(
        {
          analytics:    !!werte.analytics,
          marketing:    !!werte.marketing,
          preferences:  !!werte.preferences,
          sale_of_data: !!werte.marketing
        },
        function () { verbergen(); }
      );
    } catch (e) {
      aufgeben('setTrackingConsent hat geworfen: ' + e);
      return;
    }
    // Falls Shopify den Rueckruf nicht feuert, nicht stehen bleiben.
    setTimeout(verbergen, 1200);
  }

  function ausFeldern() {
    var w = { analytics: false, marketing: false, preferences: false };
    Array.prototype.forEach.call(felder, function (f) {
      w[f.getAttribute('data-dcc-feld')] = f.checked;
    });
    return w;
  }

  function standEinlesen() {
    if (!privacy || !privacy.currentVisitorConsent) return;
    var c;
    try { c = privacy.currentVisitorConsent(); } catch (e) { return; }
    Array.prototype.forEach.call(felder, function (f) {
      f.checked = c[f.getAttribute('data-dcc-feld')] === 'yes';
    });
  }

  /* ---------------------------------------------------------------------
     Knoepfe
     --------------------------------------------------------------------- */
  function verdrahten() {
    var alle = banner.querySelector('[data-dcc-alle]');
    var noetig = banner.querySelector('[data-dcc-noetig]');
    var speichern = banner.querySelector('[data-dcc-speichern]');

    if (alle) alle.addEventListener('click', function () {
      setzen({ analytics: true, marketing: true, preferences: true });
    });

    if (noetig) noetig.addEventListener('click', function () {
      setzen({ analytics: false, marketing: false, preferences: false });
    });

    if (speichern) speichern.addEventListener('click', function () {
      setzen(ausFeldern());
    });

    if (knopfMehr) knopfMehr.addEventListener('click', wahlUmschalten);

    // Escape schliesst nur die Feinauswahl, nie das Banner selbst —
    // die Entscheidung soll bewusst getroffen werden.
    banner.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wahl && !wahl.hidden) wahlUmschalten();
    });
  }

  /* ---------------------------------------------------------------------
     Fusszeilen-Link: die Wahl muss sich spaeter genauso leicht aendern
     lassen, wie sie getroffen wurde.
     --------------------------------------------------------------------- */
  function fusslinkSetzen() {
    var skript = document.currentScript ||
                 document.querySelector('script[data-nachtraeglich-label]');
    var label = (skript && skript.getAttribute('data-nachtraeglich-label')) ||
                'Cookie-Einstellungen';

    function einhaengen() {
      var fuss = document.querySelector('.dm-footer__bottom .dm-wrap > span') || document.querySelector('.dm-footer__bottom .dm-wrap');
      if (!fuss || fuss.querySelector('.dcc-ck-fusslink')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dcc-ck-fusslink';
      b.textContent = label;
      b.addEventListener('click', function () {
        zeigen();
        standEinlesen();
        if (wahl && wahl.hidden) wahlUmschalten();
        if (!modal) banner.scrollIntoView({ block: 'end' });
      });
      fuss.appendChild(b);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', einhaengen);
    } else {
      einhaengen();
    }
  }

  /* ---------------------------------------------------------------------
     Start — Shopifys Consent-API nachladen.
     --------------------------------------------------------------------- */
  function start() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      aufgeben('Shopify.loadFeatures nicht vorhanden');
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (fehler) {
        if (fehler || !window.Shopify.customerPrivacy) {
          aufgeben('consent-tracking-api nicht geladen');
          return;
        }

        privacy = window.Shopify.customerPrivacy;
        verdrahten();
        fusslinkSetzen();

        /* `shouldShowBanner()` allein genuegt nicht: es meldet auch dann noch
           `true`, wenn der Besucher gerade entschieden hat — es beschreibt die
           Region, nicht den Besucher. Wer sich darauf verlaesst, zeigt die
           Leiste auf jeder weiteren Seite erneut.

           Also zusaetzlich nachsehen, ob schon eine Entscheidung vorliegt.
           `currentVisitorConsent()` liefert '' (nie gefragt), 'yes' oder 'no'. */
        var regionFragt = true;
        try {
          if (typeof privacy.shouldShowBanner === 'function') {
            regionFragt = privacy.shouldShowBanner();
          }
        } catch (e) { /* im Zweifel fragen */ }

        var schonEntschieden = false;
        try {
          var c = privacy.currentVisitorConsent();
          schonEntschieden = ['analytics', 'marketing', 'preferences', 'sale_of_data']
            .some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
        } catch (e) { /* dann eben fragen */ }

        // Druckmomente liefert nur nach Deutschland: jeden fragen, der noch nicht entschieden hat.
        // (shouldShowBanner() hängt an Shopifys Regionserkennung und meldete in Tests fälschlich „nein“.)
        if (!schonEntschieden) {
          standEinlesen();
          zeigen();
        }
      }
    );
  }

  start();
})();
